import { z } from "zod";
import { EVENT_POST_CATEGORIES } from "../types/event-post.js";

// POST /events/:id/posts -- create a board post.
// `body` is free-text (Prisma @db.Text); a generous cap guards against abuse.
// `title` is optional; `category` defaults to "general".
export const createEventPostSchema = z.object({
  title: z.string().max(200).optional().nullable(),
  body: z.string().min(1, "body cannot be empty").max(20000),
  category: z.enum(EVENT_POST_CATEGORIES).optional(),
  pinned: z.boolean().optional(),
});

// PATCH /events/:id/posts/:postId -- edit own post or (organiser) pin/unpin.
// All fields optional; at least the route enforces who may set `pinned`.
export const updateEventPostSchema = z
  .object({
    title: z.string().max(200).optional().nullable(),
    body: z.string().min(1).max(20000).optional(),
    category: z.enum(EVENT_POST_CATEGORIES).optional(),
    pinned: z.boolean().optional(),
  })
  .refine((o) => Object.keys(o).length > 0, { message: "no fields to update" });

export type CreateEventPostInput = z.infer<typeof createEventPostSchema>;
export type UpdateEventPostInput = z.infer<typeof updateEventPostSchema>;
